import { Injectable } from "@angular/core";
import { EnvironmentModel } from '@modules/common/models/environment-model';
import { UserSessionService } from "@modules/common/services/user-session.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EnvironmentListService {
    private _subject = new BehaviorSubject<EnvironmentModel[]>([]);

    constructor(
        userSessionService: UserSessionService
    ) {
        userSessionService.userSessionChanged().subscribe(result => {
            const environments = result && result.allowedEnvironments as EnvironmentModel[] || [];
            environments.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            environments.sort((a, b) => a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1);
            this._subject.next(environments);
        });
    }

    public get environmentListChanged(): Observable<EnvironmentModel[]> {
        return this._subject;
    }

    public getEnvironmentList(): EnvironmentModel[] {
        return this._subject.value;
    }
}
